import { css } from '@inter-ikea-kompis/web-component';
import SummaryPagePaddingUtility from '../../utilities/SummaryPagePaddingUtility.js';
export default class SummaryPageFooterStyle {
    /**
     * Returns styles.
     *
     * @param options ...
     * @param options.theme ...
     * @param options.enableMargins ...
     * @param options.direction ...
     */
    static getStyle(options) {
        const { color } = options.theme;
        return css `
			:host {
				display: block;
			}

			kompis-text {
				color: ${color.text.dark};
			}

			footer {
				display: flex;
				align-items: center;
				background-color: ${color.background.default};
				/* Align left/right in Safari  */
				justify-content: ${options.direction === 'rtl' ? 'right' : 'left'};
				height: ${90 / 16}rem;
			}

			/* Align left/right in Firefox */
			:host(:dir(rtl)) footer {
				justify-content: right;
			}
			/* Align left/right in Chrome/Edge */
			:host-context([dir='rtl']) footer {
				justify-content: right;
			}

			${options.enableMargins
            ? SummaryPagePaddingUtility.getHorizontalPadding('footer', options.theme)
            : ''}
		`;
    }
}
//# sourceMappingURL=SummaryPageFooterStyle.js.map